// page-hatena-data.jsx — Hatena, Data. (データサイエンス & BI)
//
// 一般読者向けに本文は平易に。専門用語・テクノロジー名は補足注記で。
//
// ページ構成:
//   0. Hero (アクセシブルな導入)
//   1. What we do — 3 つの価値 (平易な言葉)
//   2. U字フロー (コの字 5 ステップ) + 各ステップの平易な説明
//   3. こんなときに (旧 Methods)
//   4. 支援に使う主なツール (旧 Tech stack をシンプル化)
//   5. アーキテクチャ + チーム
//   6. Domain coverage
//   7. From the journal
//   8. CTA bottom

(function(){
  const { HBLayout, HBSubHero, hbcp, fontEN, fontENSans, fontJP, fontMono, HB_BASE } = window;

  // ──────────────────────────────────────────────────────────────
  // 1. What we do — 3 つの価値
  // ──────────────────────────────────────────────────────────────
  const PILLARS = [
    {
      num: '01', en: 'Hypothesis-first',
      jp: '仮説から始める',
      d: 'やみくもにデータを集める前に、「何が分かったら経営判断が変わるか」を一緒に決めます。答えるべき問いを先に整えることで、無駄な分析を減らします。',
    },
    {
      num: '02', en: 'One connected pipeline',
      jp: '道具より、つながりを重視する',
      d: 'データを集める場所、整える場所、見せる場所、現場で使う場所——それぞれが分断されないよう、1 本のパイプとしてつなぎます。',
      note: '具体例: Snowflake / Databricks（データ基盤）、dbt / Airflow（整備）、Tableau / Looker Studio（可視化）。',
    },
    {
      num: '03', en: 'Closing the loop',
      jp: '分析で終わらせない',
      d: '分析結果は、報告書を作って終わりにしません。営業・経理・現場の業務システムに書き戻し、「次にどう動くか」までを設計します。',
      note: '書き戻し先の例: kintone / Salesforce など、すでに使っている CRM。',
    },
  ];

  // ──────────────────────────────────────────────────────────────
  // 2. U字フロー — 5 ステップ
  // ──────────────────────────────────────────────────────────────
  const FLOW = [
    { num:'01', en:'Hypothesis',                jp:'仮説設計',           d:'「何を確かめたいのか」を最初に決めます。事業の論点を、データで答えられる形に翻訳します。' },
    { num:'02', en:'Explore (Big Data)',        jp:'ビッグデータ探索',   d:'集まっているデータの中身を観に行きます。想定していなかった傾向や偏り、抜けを見つけ、仮説を必要に応じて更新します。' },
    { num:'03', en:'Analytics (Data Science)',  jp:'データサイエンス',   d:'集計や機械学習で、見えていなかった関係性やパターンを抽出します。事業課題に合わせて手法を選びます。' },
    { num:'04', en:'BI / Reporting',            jp:'経営レポーティング', d:'分析結果を、経営会議でそのまま使える形に整えます。チャート・KPI・ストーリーで意思決定者に届きやすく。' },
    { num:'05', en:'CRM Activation',            jp:'CRM 連携',           d:'結論を業務システムに書き戻し、営業や現場が「次に何をするか」を動かす仕組みにします。' },
  ];

  // ──────────────────────────────────────────────────────────────
  // 3. こんなときに (旧 Methods)
  // ──────────────────────────────────────────────────────────────
  const USECASES = [
    { en:'Churn / Retention', jp:'顧客の離脱を、起きる前に察知したい',         d:'過去の行動データから「離脱リスクの高い顧客」をスコアリングし、営業フォローの優先順位を変えます。' },
    { en:'Segmentation',      jp:'顧客や案件を、意味のあるグループに分けたい', d:'似た振る舞いのまとまりを統計的に見つけ、施策をグループごとに最適化します。' },
    { en:'Anomaly',           jp:'不正・異常な動きを、早く見つけたい',         d:'通常と違う動きを自動でフラグ立て。不正検知・故障兆候・離反予兆の早期発見に。' },
    { en:'Causal / A/B',      jp:'施策の効果を、厳密に評価したい',             d:'介入の前後比較ではなく、因果関係として効果を切り出します。A/B テストの設計から運用まで。' },
    { en:'Dashboards',        jp:'経営会議の数字資料を、自動化したい',         d:'毎週・毎月の手作業集計をなくし、ダッシュボードで常に最新の数字が見える状態にします。' },
    { en:'GenAI',             jp:'生成 AI を、業務分析に組み込みたい',         d:'自然言語で社内データに問い合わせできる環境や、レポート自動生成の仕組みをつくります。' },
  ];

  // ──────────────────────────────────────────────────────────────
  // 4. 支援に使う主なツール (簡略化)
  // ──────────────────────────────────────────────────────────────
  const TOOLS = [
    { jp:'データを集める場所',     en:'Storage',     items:['Snowflake', 'Databricks', 'BigQuery'] },
    { jp:'データを整える',         en:'Pipeline',    items:['dbt', 'Airflow'] },
    { jp:'分析・モデリング',       en:'Modeling',    items:['機械学習', '統計モデリング', '因果推論', '生成 AI'] },
    { jp:'経営会議に届ける',       en:'BI',          items:['Tableau', 'Looker Studio', 'Power BI'] },
    { jp:'現場の動きに変える',     en:'Activation',  items:['kintone', 'Salesforce'] },
  ];

  // ──────────────────────────────────────────────────────────────
  // 6. Domain examples
  // ──────────────────────────────────────────────────────────────
  const DOMAINS = [
    {
      tag: 'Cross-domain',
      jp: '領域横断',
      d: '「業種が決まっていないが、まず社内のデータをひと目見てほしい」という段階から相談に乗ります。M&A 後のデータ統合、新規事業の初期 KPI 設計まで。',
    },
    {
      tag: 'Consumer & Marketing',
      jp: '消費者・マーケティング',
      d: '顧客の分類、生涯価値の推定、広告施策の効果測定、離脱の予測など。BtoC サービスの実装で蓄積したナレッジを応用します。',
    },
    {
      tag: 'Manufacturing',
      jp: '製造業',
      d: '需要予測、在庫の最適化、生産・品質データの統合と可視化。工場・基幹システムの数字を経営会議に届く形に整えます。',
    },
    {
      tag: 'Finance',
      jp: '金融',
      d: '価格・リスクのモデル、バックオフィスの DX、取引・与信の異常検知、監査対応のデータ整備など。',
    },
    {
      tag: 'Healthcare',
      jp: '医療・ヘルスケア',
      d: 'レセプト・電子カルテ・ゲノムデータの分析、コホート解析、予測モデルの構築。製薬・医療機器・ヘルスケアスタートアップのプロジェクトに対応します。',
    },
  ];

  // ──────────────────────────────────────────────────────────────
  // 7. From the journal
  // ──────────────────────────────────────────────────────────────
  const JOURNAL = [
    { eyebrow:'DATA PLATFORM',  title:'Snowflake 全機能ガイド｜データクラウドの基本機能と活用ポイントを徹底解説',                  url:'/blog/snowflake-features-guide/',          excerpt:'データウェアハウスの基盤となる Snowflake の機能体系を網羅的に解説。ビッグデータ探索・管理の要となるプラットフォーム入門。',                  date:'2026-05-08' },
    { eyebrow:'BI',             title:'Snowflake + Streamlit in Snowflake で売上ダッシュボードを構築する【実践編】',              url:'/blog/snowflake-streamlit-dashboard/',     excerpt:'Snowflake 内でダッシュボードを実装する実践ガイド。BI レポーティング層をコード資産として管理。',                                              date:'2026-05-08' },
    { eyebrow:'MODELING',       title:'ベイズ隠れマルコフモデルで「見えない解約リスク」を可視化する｜SaaS 行動ログから推定',       url:'/blog/marketing-data-science-bayesian-2/', excerpt:'統計モデル・機械学習で顧客行動から隠れた離脱リスクを抽出。予測モデル設計の実装例。',                                                          date:'2026-05-07' },
    { eyebrow:'BI × CRM',       title:'Salesforce CRM Analytics 入門｜Tableau に近い BI 機能を Salesforce 内で実現する',          url:'/blog/salesforce-crm-analytics/',          excerpt:'CRM 内ネイティブの BI 機能を使った分析・レポーティング。意思決定を運用化するレポート層の設計。',                                              date:'2026-05-15' },
    { eyebrow:'NLP / VOC',      title:'ゼロから理解する VoC 分析｜「顧客の声」を AI で意思決定に変える 4 ステップ入門',           url:'/blog/what-is-voc-analytics/',             excerpt:'非構造データ（テキスト）を分析対象にして経営示唆を抽出。自然言語処理・分類を含む分析実装。',                                                  date:'2026-05-15' },
    { eyebrow:'AI STRATEGY',    title:'エンタープライズ AI 導入を「試す」から「業務にする」へ｜スケール 4 段階の設計ポイント',      url:'/blog/enterprise-ai-scale-stages-2026/',   excerpt:'AI 分析導入の段階的スケール戦略。パイロット → 本格運用への移行設計と組織構築。',                                                                date:'2026-05-15' },
  ];

  // ──────────────────────────────────────────────────────────────
  // [Codex SVG] コの字 U字フロー図
  // ──────────────────────────────────────────────────────────────
  function UShapedFlowDiagram() {
    const nodes = [
      { n: '01', en: 'Hypothesis',                  jp: '仮説設計',           sub: '何を確かめるか',         color: '#1F61AB', x: 140,  y: 110, row: 'top' },
      { n: '02', en: 'Explore (Big Data)',          jp: 'ビッグデータ探索',   sub: 'データを観に行く',       color: '#1F61AB', x: 590,  y: 110, row: 'top' },
      { n: '03', en: 'Analytics (Data Science)',    jp: 'データサイエンス',   sub: 'パターンを抽出する',     color: '#0B2A57', x: 1040, y: 110, row: 'top' },
      { n: '04', en: 'BI / Reporting',              jp: '経営レポーティング', sub: '経営会議に届ける',       color: '#A65A38', x: 1040, y: 350, row: 'bottom' },
      { n: '05', en: 'CRM Activation',              jp: 'CRM 連携',           sub: '現場の動きに変える',     color: '#1A4D4D', x: 140,  y: 350, row: 'bottom' },
    ];
    const r = 38, gap = 6;
    const serif = '"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif';
    const sans  = 'Zen Kaku Gothic New, sans-serif';
    const jpFont = 'Zen Kaku Gothic New, sans-serif';
    return (
      <svg viewBox="0 0 1180 460" role="img" aria-label="Hatenabase データサイエンス 5 ステップ コの字フロー" style={{width:'100%', height:'auto', display:'block'}}>
        <defs>
          <marker id="hb-uflow-arrow-top" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="7" markerHeight="7" orient="auto-start-reverse"><path d="M0,0 L10,5 L0,10 z" fill="#1F61AB"/></marker>
          <marker id="hb-uflow-arrow-mid" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="7" markerHeight="7" orient="auto-start-reverse"><path d="M0,0 L10,5 L0,10 z" fill="#0B2A57"/></marker>
          <marker id="hb-uflow-arrow-bot" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="7" markerHeight="7" orient="auto-start-reverse"><path d="M0,0 L10,5 L0,10 z" fill="#A65A38"/></marker>
        </defs>
        <line x1={140 + r + gap} y1={110} x2={590 - r - gap}  y2={110} stroke="#1F61AB" strokeWidth="2" markerEnd="url(#hb-uflow-arrow-top)"/>
        <line x1={590 + r + gap} y1={110} x2={1040 - r - gap} y2={110} stroke="#1F61AB" strokeWidth="2" markerEnd="url(#hb-uflow-arrow-top)"/>
        <line x1={1040} y1={110 + r + gap} x2={1040} y2={350 - r - gap} stroke="#0B2A57" strokeWidth="2" markerEnd="url(#hb-uflow-arrow-mid)"/>
        <text x={1064} y={230} fontFamily={sans}   fontSize="9"  letterSpacing="2" fill="#0B2A57" textAnchor="start">SYNTHESIS</text>
        <text x={1064} y={246} fontFamily={jpFont} fontSize="11" fontWeight="700"  fill="#0B2A57" textAnchor="start">示唆化</text>
        <line x1={1040 - r - gap} y1={350} x2={140 + r + gap} y2={350} stroke="#A65A38" strokeWidth="2" markerEnd="url(#hb-uflow-arrow-bot)"/>
        <line x1={140} y1={350 - r - gap} x2={140} y2={110 + r + gap} stroke="#A65A38" strokeWidth="1.5" strokeDasharray="2 6" opacity="0.55"/>
        <text x={116} y={230} fontFamily={sans}   fontSize="9"  letterSpacing="2" fill="#A65A38" textAnchor="end">NEXT HYPOTHESIS LOOP</text>
        <text x={116} y={246} fontFamily={jpFont} fontSize="11" fontWeight="700"  fill="#A65A38" textAnchor="end">次の仮説へ</text>
        {nodes.map((nd) => {
          const isTop = nd.row === 'top';
          const jpY  = isTop ? nd.y + r + 24 : nd.y - r - 30;
          const subY = isTop ? jpY + 18      : jpY - 18;
          return (
            <g key={nd.n}>
              <circle cx={nd.x} cy={nd.y} r={r} fill="#FFFFFF" stroke={nd.color} strokeWidth="2"/>
              <text x={nd.x} y={nd.y + 2}  fontFamily={serif} fontSize="20" fill={nd.color} textAnchor="middle">{nd.n}</text>
              <text x={nd.x} y={nd.y + 18} fontFamily={sans}  fontSize="9" letterSpacing="2" fill={nd.color} textAnchor="middle">{nd.en.toUpperCase()}</text>
              <text x={nd.x} y={jpY}       fontFamily={jpFont} fontSize="14" fontWeight="700" fill="#0A2846" textAnchor="middle">{nd.jp}</text>
              <text x={nd.x} y={subY}      fontFamily={sans}   fontSize="12" fill="#6b6864" textAnchor="middle">{nd.sub}</text>
            </g>
          );
        })}
      </svg>
    );
  }

  // ──────────────────────────────────────────────────────────────
  // [Codex SVG] 3 層構造図
  // ──────────────────────────────────────────────────────────────
  function OntologyDiagram() {
    return (
      <svg viewBox="0 0 480 280" role="img" aria-label="データ → 分析 → 現場 の 3 層構造図" style={{width:'100%', height:'auto', display:'block'}}>
        <rect x="40" y="34"  width="400" height="60" rx="4" fill="#1F61AB" opacity=".10"/>
        <text x="60" y="58" fontFamily="Zen Kaku Gothic New, sans-serif" fontSize="10" letterSpacing="2.6" fill="#1F61AB" fontWeight="700">L1 — DATA</text>
        <text x="60" y="80" fontFamily="Zen Kaku Gothic New, sans-serif" fontSize="14" fontWeight="700" fill="#0A2846">生データを集める場所</text>
        <rect x="40" y="110" width="400" height="60" rx="4" fill="#A65A38" opacity=".10"/>
        <text x="60" y="134" fontFamily="Zen Kaku Gothic New, sans-serif" fontSize="10" letterSpacing="2.6" fill="#A65A38" fontWeight="700">L2 — ANALYTICS &amp; BI</text>
        <text x="60" y="156" fontFamily="Zen Kaku Gothic New, sans-serif" fontSize="14" fontWeight="700" fill="#0A2846">分析と、経営に届ける可視化</text>
        <rect x="40" y="186" width="400" height="60" rx="4" fill="#1A4D4D" opacity=".12"/>
        <text x="60" y="210" fontFamily="Zen Kaku Gothic New, sans-serif" fontSize="10" letterSpacing="2.6" fill="#1A4D4D" fontWeight="700">L3 — ACTIVATION</text>
        <text x="60" y="232" fontFamily="Zen Kaku Gothic New, sans-serif" fontSize="14" fontWeight="700" fill="#0A2846">現場の業務システムにつなぐ</text>
        <path d="M 240 96 L 240 108" stroke="#0A2846" strokeWidth="1.5" markerEnd="url(#hb-ont-arrow)"/>
        <path d="M 240 172 L 240 184" stroke="#0A2846" strokeWidth="1.5" markerEnd="url(#hb-ont-arrow)"/>
        <defs>
          <marker id="hb-ont-arrow" markerWidth="10" markerHeight="10" refX="6" refY="5" orient="auto-start-reverse">
            <path d="M 0 0 L 8 5 L 0 10 z" fill="#0A2846"/>
          </marker>
        </defs>
      </svg>
    );
  }

  // ──────────────────────────────────────────────────────────────
  // [Codex SVG] データチーム描画
  // ──────────────────────────────────────────────────────────────
  function DataTeamScene() {
    return (
      <svg viewBox="0 0 480 320" role="img" aria-label="データサイエンスチームが分析結果をダッシュボードに翻訳する様子" style={{width:'100%', height:'auto', display:'block'}}>
        <ellipse cx="240" cy="285" rx="200" ry="20" fill="#1F61AB" opacity=".08"/>
        <rect x="60" y="240" width="360" height="6" fill="#0A2846"/>
        <rect x="120" y="100" width="240" height="135" rx="6" fill="#0A2846"/>
        <rect x="128" y="108" width="224" height="119" rx="2" fill="#fff"/>
        <rect x="140" y="190" width="14" height="32" fill="#1F61AB"/>
        <rect x="160" y="170" width="14" height="52" fill="#1F61AB"/>
        <rect x="180" y="180" width="14" height="42" fill="#A65A38"/>
        <rect x="200" y="155" width="14" height="67" fill="#1F61AB"/>
        <rect x="220" y="200" width="14" height="22" fill="#1A4D4D"/>
        <polyline points="250,200 268,184 285,192 305,168 322,176 340,150" fill="none" stroke="#1F61AB" strokeWidth="2.5"/>
        {[ [250,200], [268,184], [285,192], [305,168], [322,176], [340,150]].map(([x,y],i)=>(
          <circle key={i} cx={x} cy={y} r="3" fill="#A65A38"/>
        ))}
        <rect x="232" y="235" width="16" height="6" fill="#0A2846"/>
        <ellipse cx="92" cy="240" rx="14" ry="4" fill="#0A2846"/>
        <rect x="80" y="210" width="24" height="30" rx="3" fill="#A65A38"/>
        <path d="M104 215 q 12 5 0 18" fill="none" stroke="#A65A38" strokeWidth="2"/>
        <circle cx="395" cy="180" r="20" fill="#f1c7a3"/>
        <path d="M380 168 q 15 -22 32 -4 q 6 8 -1 12 q -16 -2 -31 -8 z" fill="#0A2846"/>
        <rect x="370" y="200" width="50" height="44" rx="8" fill="#1F61AB"/>
        <rect x="376" y="244" width="14" height="20" fill="#0A2846"/>
        <rect x="402" y="244" width="14" height="20" fill="#0A2846"/>
        <g opacity=".55">
          <circle cx="60" cy="80" r="12" fill="none" stroke="#1F61AB" strokeWidth="1.5"/>
          <circle cx="60" cy="80" r="5" fill="#1F61AB"/>
          <rect x="40" y="125" width="14" height="14" fill="none" stroke="#A65A38" strokeWidth="1.5"/>
          <rect x="44" y="129" width="6" height="6" fill="#A65A38"/>
          <path d="M420 60 l 12 14 l -24 0 z" fill="none" stroke="#1A4D4D" strokeWidth="1.5"/>
          <path d="M414 70 l 6 4" stroke="#1A4D4D" strokeWidth="1.5"/>
        </g>
      </svg>
    );
  }

  // ──────────────────────────────────────────────────────────────
  function HatenaDataPage() {
    return (
      <HBLayout>
        <HBSubHero
          crumb={`Service / データサイエンス & BI`}
          en="Data Science & BI"
          jp={<span>データを集めるだけ、可視化するだけで、<br/>終わらせない。<br/><span style={{color:hbcp.blue}}>意思決定の現場まで</span>つなぎます。</span>}
          tag={'From hypothesis to operationalized decisions.'}
          lead={'「データを集めれば何かが見える」「ダッシュボードを作れば判断が速くなる」——よく聞く話ですが、それだけでは多くの場合うまくいきません。Hatenabase は、仮説を立てる → データを観に行く → 分析でパターンを掴む → 経営会議で使える形に整える → 営業や現場の動きに反映させる、という流れを丸ごと伴走します。'}
        />

        {/* 1. What we do — 3 Pillars */}
        <section style={{padding:'96px 32px', background:hbcp.white, borderBottom:`1px solid ${hbcp.line}`}}>
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">What we do</span>
              <span className="hb-section-head-jp">私たちが大事にしている 3 つのこと</span>
              <span style={{marginLeft:'auto', fontFamily:fontENSans, fontSize:11, letterSpacing:'.18em', color:hbcp.inkLight}}>03 PILLARS</span>
            </div>
            <div style={{display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:0, borderTop:`1px solid ${hbcp.line}`, borderLeft:`1px solid ${hbcp.line}`}}>
              {PILLARS.map(p => (
                <div key={p.num} style={{padding:'40px 32px', borderRight:`1px solid ${hbcp.line}`, borderBottom:`1px solid ${hbcp.line}`}}>
                  <div style={{display:'flex', alignItems:'baseline', gap:14, marginBottom:18}}>
                    <span style={{fontFamily:fontEN, fontWeight:300, fontSize:36, color:hbcp.blue, lineHeight:1}}>{p.num}</span>
                    <span style={{fontFamily:fontENSans, fontSize:10.5, letterSpacing:'.28em', fontWeight:700, color:hbcp.inkLight}}>{p.en.toUpperCase()}</span>
                  </div>
                  <h3 style={{fontFamily:fontJP, fontWeight:800, fontSize:22, lineHeight:1.4, letterSpacing:'.04em', margin:'2px 0 12px', color:hbcp.ink}}>{p.jp}</h3>
                  <p style={{fontSize:14, lineHeight:1.95, color:hbcp.inkSoft, margin:0}}>{p.d}</p>
                  {p.note && (
                    <p style={{marginTop:14, padding:'10px 12px', background:hbcp.paper, fontSize:11.5, lineHeight:1.7, color:hbcp.inkLight, borderLeft:`2px solid ${hbcp.line}`}}>
                      {p.note}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 2. U-shaped Flow */}
        <section style={{padding:'96px 32px', background:hbcp.paper}}>
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">How we work</span>
              <span className="hb-section-head-jp">仮説からはじまり、現場の動きに戻ってくる 5 つのステップ</span>
              <span style={{marginLeft:'auto', fontFamily:fontENSans, fontSize:11, letterSpacing:'.18em', color:hbcp.inkLight}}>05 STEPS</span>
            </div>
            <div className="hb-flow-diagram" style={{background:'#fff', border:`1px solid ${hbcp.line}`, padding:'32px 32px 40px', marginBottom:32, overflowX:'auto'}}>
              <UShapedFlowDiagram/>
            </div>
            <p style={{fontSize:12.5, lineHeight:1.9, color:hbcp.inkLight, margin:'0 0 24px', maxWidth:880}}>
              右上 → 折り返し → 左下、そして左端の点線で次の仮説へ戻る——分析を 1 回きりの納品物ではなく、改善が続いていくループとして設計しています。
            </p>
            <div style={{display:'grid', gridTemplateColumns:'repeat(5, 1fr)', gap:0, borderTop:`1px solid ${hbcp.line}`, borderLeft:`1px solid ${hbcp.line}`, background:'#fff'}}>
              {FLOW.map(f => (
                <div key={f.num} style={{padding:'28px 24px', borderRight:`1px solid ${hbcp.line}`, borderBottom:`1px solid ${hbcp.line}`}}>
                  <div style={{display:'flex', alignItems:'baseline', gap:10, marginBottom:12}}>
                    <span style={{fontFamily:fontEN, fontWeight:300, fontSize:28, color:hbcp.blue, lineHeight:1}}>{f.num}</span>
                    <span style={{fontFamily:fontENSans, fontSize:10, letterSpacing:'.24em', fontWeight:700, color:hbcp.inkLight}}>{f.en.toUpperCase()}</span>
                  </div>
                  <h4 style={{fontFamily:fontJP, fontWeight:800, fontSize:16, lineHeight:1.4, margin:'0 0 10px', color:hbcp.ink}}>{f.jp}</h4>
                  <p style={{fontSize:12.5, lineHeight:1.8, color:hbcp.inkSoft, margin:0}}>{f.d}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 3. Use cases (旧 Methods) */}
        <section style={{padding:'96px 32px', background:hbcp.white, borderBottom:`1px solid ${hbcp.line}`}}>
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">When to use us</span>
              <span className="hb-section-head-jp">こんなときに、ご相談ください</span>
              <span style={{marginLeft:'auto', fontFamily:fontENSans, fontSize:11, letterSpacing:'.18em', color:hbcp.inkLight}}>06 USE CASES</span>
            </div>
            <div style={{display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:0, borderTop:`1px solid ${hbcp.line}`, borderLeft:`1px solid ${hbcp.line}`}}>
              {USECASES.map(c => (
                <div key={c.en} style={{padding:'28px 24px', borderRight:`1px solid ${hbcp.line}`, borderBottom:`1px solid ${hbcp.line}`}}>
                  <div style={{fontFamily:fontENSans, fontSize:10, letterSpacing:'.28em', fontWeight:700, color:hbcp.blue, marginBottom:10}}>● {c.en.toUpperCase()}</div>
                  <h4 style={{fontFamily:fontJP, fontWeight:700, fontSize:16, lineHeight:1.55, margin:'0 0 10px', color:hbcp.ink}}>{c.jp}</h4>
                  <p style={{fontSize:13, lineHeight:1.85, color:hbcp.inkSoft, margin:0}}>{c.d}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 4. 支援に使う主なツール */}
        <section style={{padding:'96px 32px', background:hbcp.paper}}>
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Tools — examples</span>
              <span className="hb-section-head-jp">使うツール例</span>
              <span style={{marginLeft:'auto', fontFamily:fontENSans, fontSize:11, letterSpacing:'.18em', color:hbcp.inkLight}}>EXAMPLES ONLY</span>
            </div>
            <p style={{fontSize:13.5, lineHeight:1.95, color:hbcp.inkSoft, margin:'0 0 28px', maxWidth:880}}>
              下記はあくまで <strong style={{color:hbcp.ink}}>一例</strong> です。組織の規模・既存環境・予算・コンプライアンス要件に合わせて、これら以外のツールも含めてフラットに比較・選定します。特定のベンダーに限定した対応ではありません。
            </p>
            <div style={{display:'grid', gridTemplateColumns:'repeat(5, 1fr)', gap:0, borderTop:`1px solid ${hbcp.line}`, borderLeft:`1px solid ${hbcp.line}`, background:'#fff'}}>
              {TOOLS.map(t => (
                <div key={t.en} style={{padding:'24px 20px', borderRight:`1px solid ${hbcp.line}`, borderBottom:`1px solid ${hbcp.line}`}}>
                  <div style={{fontFamily:fontENSans, fontSize:10, letterSpacing:'.28em', fontWeight:700, color:hbcp.blue, marginBottom:10}}>{t.en.toUpperCase()}</div>
                  <h4 style={{fontFamily:fontJP, fontWeight:700, fontSize:14, lineHeight:1.45, margin:'0 0 12px', color:hbcp.ink}}>{t.jp}</h4>
                  <div style={{display:'flex', flexDirection:'column', gap:6}}>
                    {t.items.map(it => (
                      <span key={it} style={{display:'inline-block', padding:'4px 10px', background:hbcp.paper, fontFamily:fontMono, fontSize:11, fontWeight:600, color:hbcp.ink, letterSpacing:'.02em', alignSelf:'flex-start'}}>{it}</span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 5. Architecture + Team */}
        <section style={{padding:'96px 32px', background:hbcp.white, borderBottom:`1px solid ${hbcp.line}`}}>
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Architecture &amp; team</span>
              <span className="hb-section-head-jp">設計の考え方と、それを動かすチーム</span>
              <span style={{marginLeft:'auto', fontFamily:fontENSans, fontSize:11, letterSpacing:'.18em', color:hbcp.inkLight}}>3 LAYERS</span>
            </div>
            <div className="hb-illust-grid" style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:32, alignItems:'stretch'}}>
              <div style={{background:hbcp.paper, border:`1px solid ${hbcp.line}`, padding:'32px'}}>
                <div style={{fontFamily:fontENSans, fontSize:10.5, letterSpacing:'.32em', fontWeight:700, color:hbcp.blue, marginBottom:14}}>● ARCHITECTURE</div>
                <h3 style={{fontFamily:fontJP, fontWeight:800, fontSize:20, lineHeight:1.45, margin:'0 0 18px', color:hbcp.ink}}>「データ」「分析」「現場」を、別々に設計する</h3>
                <OntologyDiagram/>
                <p style={{fontSize:13, lineHeight:1.85, color:hbcp.inkSoft, margin:'18px 0 0'}}>
                  データを差し替えても、分析のやり方を変えても、現場の使い方を変えても、それぞれが独立して動けるように、3 つの層を分けて設計します。新しいデータが増えたとき、新しい施策を始めるとき、後戻りが少なくて済みます。
                </p>
              </div>
              <div style={{background:hbcp.paper, border:`1px solid ${hbcp.line}`, padding:'32px', display:'flex', flexDirection:'column'}}>
                <div style={{fontFamily:fontENSans, fontSize:10.5, letterSpacing:'.32em', fontWeight:700, color:hbcp.blue, marginBottom:14}}>● TEAM IN ACTION</div>
                <h3 style={{fontFamily:fontJP, fontWeight:800, fontSize:20, lineHeight:1.45, margin:'0 0 18px', color:hbcp.ink}}>分析を、ダッシュボードに翻訳する</h3>
                <div style={{flex:1, display:'flex', alignItems:'center', justifyContent:'center', minHeight:240}}>
                  <DataTeamScene/>
                </div>
                <p style={{fontSize:13, lineHeight:1.85, color:hbcp.inkSoft, margin:'18px 0 0'}}>
                  業界・業務の勘所が分かるアナリストと、業務システム（CRM や基幹系）まで触れるエンジニアが、同じテーブルで作業します。分析の結論を「現場で動く KPI」に着地させるための混成チームです。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* 6. Domain examples */}
        <section style={{padding:'96px 32px', background:hbcp.paper}}>
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Where we work</span>
              <span className="hb-section-head-jp">対応する領域</span>
              <span style={{marginLeft:'auto', fontFamily:fontENSans, fontSize:11, letterSpacing:'.18em', color:hbcp.inkLight}}>{String(DOMAINS.length).padStart(2,'0')} DOMAINS</span>
            </div>
            <div style={{display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:0, borderTop:`1px solid ${hbcp.line}`, borderLeft:`1px solid ${hbcp.line}`, background:'#fff'}}>
              {DOMAINS.map(dm => (
                <div key={dm.tag} style={{padding:'32px 28px', borderRight:`1px solid ${hbcp.line}`, borderBottom:`1px solid ${hbcp.line}`}}>
                  <div style={{fontFamily:fontENSans, fontSize:10.5, letterSpacing:'.28em', fontWeight:700, color:hbcp.blue, marginBottom:10}}>● {dm.tag.toUpperCase()}</div>
                  <h4 style={{fontFamily:fontJP, fontWeight:700, fontSize:18, lineHeight:1.45, margin:'0 0 10px', color:hbcp.ink}}>{dm.jp}</h4>
                  <p style={{fontSize:13.5, lineHeight:1.85, color:hbcp.inkSoft, margin:0}}>{dm.d}</p>
                </div>
              ))}
            </div>
            <p style={{marginTop:18, fontSize:12, lineHeight:1.85, color:hbcp.inkLight}}>
              ※ 業種が決まっていない段階のご相談も歓迎です。
            </p>
          </div>
        </section>

        {/* 7. From the journal */}
        {JOURNAL.length >= 3 && (
          <section style={{padding:'96px 32px', background:hbcp.white, borderBottom:`1px solid ${hbcp.line}`}}>
            <div style={{maxWidth:1280, margin:'0 auto'}}>
              <div className="hb-section-head">
                <span className="hb-section-head-en">From the journal</span>
                <span className="hb-section-head-jp">データサイエンス関連の記事</span>
                <span style={{marginLeft:'auto', fontFamily:fontENSans, fontSize:11, letterSpacing:'.18em', color:hbcp.inkLight}}>READ MORE</span>
              </div>
              <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(300px, 1fr))', gap:18}}>
                {JOURNAL.slice(0, 6).map(j => (
                  <a key={j.url} href={`${HB_BASE}${j.url}`} className="hb-data-rel-card" style={{display:'flex', flexDirection:'column', padding:'24px 22px', border:`1px solid ${hbcp.line}`, background:'#fff', textDecoration:'none', color:hbcp.ink, transition:'transform .15s ease, border-color .15s ease, box-shadow .15s ease'}}>
                    <div style={{fontFamily:fontENSans, fontSize:10, letterSpacing:'.28em', fontWeight:700, color:hbcp.blue, marginBottom:14}}>● {j.eyebrow}</div>
                    <h4 style={{fontFamily:fontJP, fontWeight:700, fontSize:15.5, lineHeight:1.55, letterSpacing:'.04em', margin:'0 0 10px', color:hbcp.ink, display:'-webkit-box', WebkitLineClamp:3, WebkitBoxOrient:'vertical', overflow:'hidden'}}>{j.title}</h4>
                    <p style={{fontSize:12.5, lineHeight:1.8, color:hbcp.inkSoft, margin:'0 0 14px', display:'-webkit-box', WebkitLineClamp:3, WebkitBoxOrient:'vertical', overflow:'hidden'}}>{j.excerpt}</p>
                    <div style={{marginTop:'auto', display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                      <span style={{fontFamily:fontMono, fontSize:11, color:hbcp.inkLight}}>{j.date}</span>
                      <span style={{fontFamily:fontEN, fontSize:18, color:hbcp.blue}}>→</span>
                    </div>
                  </a>
                ))}
              </div>
              <div style={{marginTop:32, textAlign:'right'}}>
                <a href={`${HB_BASE}/blog/`} style={{fontFamily:fontJP, fontSize:13.5, fontWeight:700, color:hbcp.ink, textDecoration:'none', borderBottom:`1px solid ${hbcp.ink}`, paddingBottom:2}}>
                  ジャーナル一覧へ <span style={{fontFamily:fontEN}}>→</span>
                </a>
              </div>
            </div>
          </section>
        )}

        {/* 8. CTA bottom */}
        <section style={{padding:'96px 32px', background:hbcp.blue, color:'#fff', position:'relative', overflow:'hidden'}}>
          <svg style={{position:'absolute', top:'50%', right:-200, transform:'translateY(-50%)', width:560, height:560, opacity:.18}} viewBox="0 0 560 560">
            {[...Array(12)].map((_,i)=>(<circle key={i} cx="280" cy="280" r={30+i*20} fill="none" stroke="#fff" strokeWidth=".7"/>))}
          </svg>
          <div style={{position:'relative', maxWidth:1280, margin:'0 auto', display:'grid', gridTemplateColumns:'1.4fr 1fr', gap:64, alignItems:'flex-end'}}>
            <div>
              <div style={{fontFamily:fontENSans, fontSize:11, letterSpacing:'.32em', opacity:.85, marginBottom:18}}>● CONTACT — まず仮説の段階から話す</div>
              <h2 style={{fontFamily:fontJP, fontWeight:900, fontSize:'clamp(36px, 4.5vw, 56px)', lineHeight:1.4, letterSpacing:'.04em', margin:'0 0 24px'}}>
                データは、<br/>使われて初めて<br/>意思決定になる。
              </h2>
              <p style={{fontSize:15, lineHeight:1.95, opacity:.9, margin:0, maxWidth:560}}>
                どの数字を、誰に、いつ届けるか。「まず社内のデータをひと目見てほしい」という段階から、お気軽にご相談ください。
              </p>
            </div>
            <div style={{display:'grid', gap:14}}>
              <a href={`${HB_BASE}/contact`} style={{padding:'18px 28px', background:'#fff', color:hbcp.blue, textDecoration:'none', fontFamily:fontJP, fontSize:15, fontWeight:700, display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <span>無料相談を予約する</span>
                <span style={{fontFamily:fontEN}}>→</span>
              </a>
              <a href={`${HB_BASE}/hatena-account`} style={{padding:'18px 28px', background:'transparent', color:'#fff', border:'1px solid rgba(255,255,255,.6)', textDecoration:'none', fontFamily:fontJP, fontSize:15, fontWeight:600, display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <span>会計業務全体の支援 (Account.) を見る</span>
                <span style={{fontFamily:fontEN}}>↗</span>
              </a>
            </div>
          </div>
        </section>

        {/* Responsive */}
        <style>{`
          .hb-data-rel-card:hover { transform: translateY(-2px); border-color: ${hbcp.blueLight || '#7BA7D9'}; box-shadow: 0 8px 24px rgba(31,97,171,.12); }

          @media (min-width: 1025px) {
            .hb-flow-diagram svg { width: 100%; height: auto; }
          }
          @media (min-width: 721px) and (max-width: 1024px) {
            .hb-flow-diagram { overflow-x: auto; }
            .hb-flow-diagram svg { min-width: 720px; }
          }

          @media (max-width: 900px) {
            section [style*="grid-template-columns: repeat(3, 1fr)"] {
              grid-template-columns: repeat(2, 1fr) !important;
            }
            section [style*="grid-template-columns: repeat(5, 1fr)"] {
              grid-template-columns: repeat(2, 1fr) !important;
            }
            .hb-illust-grid {
              grid-template-columns: 1fr !important;
              gap: 20px !important;
            }
          }

          @media (max-width: 720px) {
            .hb-section-head { flex-wrap: wrap !important; }
            .hb-flow-diagram { display: none !important; }
            section[style*="padding: 96px 32px"] { padding: 56px 16px !important; }
            .hb-illust-grid > div { padding: 24px 18px !important; }
            section[style*="background:#1F61AB"] > svg,
            section[style*="background: #1F61AB"] > svg {
              width: 360px !important; height: 360px !important; right: -160px !important;
            }
            section [style*="grid-template-columns: repeat(3, 1fr)"] {
              grid-template-columns: 1fr !important;
            }
            section [style*="grid-template-columns: repeat(2, 1fr)"] {
              grid-template-columns: 1fr !important;
            }
            section [style*="grid-template-columns: 1.4fr 1fr"] {
              grid-template-columns: 1fr !important;
              gap: 28px !important;
            }
            .hb-illust-grid svg { max-width: 100%; height: auto; }
          }
        `}</style>
      </HBLayout>
    );
  }

  Object.assign(window, { HatenaDataPage });
})();
